import type { PaidPlanId, PlanId, ProjectToolSlug } from '../types';

const PAID_PLAN_IDS = new Set<PlanId>(['base', 'research']);
const TRACKER_TOOL_SLUG: ProjectToolSlug = 'tracker';

export function isPaidPlan(planId: PlanId | null | undefined): planId is PaidPlanId {
  return Boolean(planId && PAID_PLAN_IDS.has(planId));
}

export function isProjectToolAccessible(
  toolSlug: ProjectToolSlug,
  planId: PlanId | null | undefined,
  trackerEnabled: boolean,
): boolean {
  if (!isPaidPlan(planId)) return false;

  if (toolSlug === TRACKER_TOOL_SLUG) {
    return trackerEnabled;
  }

  return true;
}
